import React from 'react'
import { Link } from 'react-router-dom'
import propTypes from 'prop-types'
import Image from '../Image/Image'
import { useAuth } from '../../../context/Auth'
import FaIcon from '../FaIcon/FaIcon'
import Tag from '../Tag/Tag'

import './Card.scss'

const Card = ({ project, type }) => {
  const { currentUser, setShowModal, setDestination } = useAuth()

  const typeClass = (t) => {
    let type
    switch (t) {
      case 'narrow':
        type = 'narrow'
        break
      case 'wide':
        type = 'wide'
        break
      default:
        console.log(`Invalid type: ${type}`)
    }
    return type
  }

  return !currentUser && project.locked ? (
    <div
      className={`card placeholder ${typeClass(type)}`}
      tabIndex={0}
      key={project.url}
      onClick={() => {
        setShowModal(true)
        setDestination({ name: project.name, url: `/work/${project.url}` })
      }}>
      <div className='card-text'>
        <Tag label={project.tag} className={type === 'narrow' ? 'tab' : ''} />
        <span className='card-name'>{project.nameAlias}</span>
        <span className='card-description'>{project.descriptionAlias}</span>
      </div>
      <div className='image-wrapper locked'>
        <FaIcon name='lock' />
      </div>
    </div>
  ) : (
    <Link
      className={`card ${typeClass(type)}`}
      to={`/work/${project.url}`}
      key={project.url}>
      <div className='card-text'>
        <Tag label={project.tag} className={type === 'narrow' ? 'tab' : ''} />
        <span className='card-name'>{project.name}</span>
        <span className='card-description'>{project.description}</span>
      </div>
      <Image
        path={`projects/${project.url}`}
        className='cover'
        alt={`${project.name} cover image`}
        cover={project.cover}
      />
    </Link>
  )
}

Card.propTypes = {
  type: propTypes.string,
  project: propTypes.shape({
    cover: propTypes.string,
    description: propTypes.string,
    name: propTypes.string,
    url: propTypes.string,
    tag: propTypes.string,
    nameAlias: propTypes.string,
    descriptionAlias: propTypes.string,
    locked: propTypes.bool,
  }).isRequired,
}

export default Card
